<template>
  <page>
    <lazy-div>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newMode">mdi-plus</v-icon>
          <v-icon v-else-if="reviewMode">mdi-pencil</v-icon>
          <v-icon v-else-if="queryMode">mdi-magnify</v-icon>
          <v-toolbar-title v-if="newMode">Create New Promotion</v-toolbar-title>
          <v-toolbar-title v-else-if="reviewMode">Edit Promotion</v-toolbar-title>
          <v-toolbar-title v-else-if="queryMode">Query Promotion</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ labels.promo_campaign }}</v-subheader>
                <div class="queryValue">{{ form.promo_campaign }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-text-field
                  v-model="form.promo_campaign"
                  :label="labels.promo_campaign"
                  :error-messages="errors.collect('promo_campaign')"
                  data-vv-name="promo_campaign"
                  :data-vv-as="labels.promo_campaign"
                  v-validate="'required|max:12'"
                ></v-text-field>
              </v-flex>

              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.promo_description }}</v-subheader>
                <div class="queryValue">{{ form.promo_description }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-text-field
                  v-model="form.promo_description"
                  :label="labels.promo_description"
                  :error-messages="errors.collect('promo_description')"
                  data-vv-name="promo_description"
                  :data-vv-as="labels.promo_description"
                  v-validate="'required|max:128'"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.promo_effDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(form.promo_effDate) }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <cal-picker
                  :label="labels.promo_effDate"
                  v-model="form.promo_effDate"
                  :error-messages="errors.collect('promo_effDate')"
                  data-vv-name="promo_effDate"
                  :data-vv-as="labels.promo_effDate"
                  v-validate="effDateValidation"
                ></cal-picker>
              </v-flex>

              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.promo_expDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(form.promo_expDate) }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <cal-picker
                  :label="labels.promo_expDate"
                  v-model="form.promo_expDate"
                  :error-messages="errors.collect('promo_expDate')"
                  data-vv-name="promo_expDate"
                  :data-vv-as="labels.promo_expDate"
                  v-validate="expDateValidation"
                ></cal-picker>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs6 v-if="queryMode">
                <v-checkbox readonly v-model="form.promo_stdPromo" :label="labels.promo_stdPromo"></v-checkbox>
              </v-flex>
              <v-flex xs6 v-else>
                <v-checkbox
                  v-model="form.promo_stdPromo"
                  :label="labels.promo_stdPromo"
                  :error-messages="errors.collect('promo_stdPromo')"
                  data-vv-name="promo_stdPromo"
                  :data-vv-as="labels.promo_stdPromo"
                  v-validate="'required'"
                ></v-checkbox>
              </v-flex>

              <v-flex xs6 v-if="queryMode">
                <v-checkbox readonly v-model="form.promo_cardPromo" :label="labels.promo_cardPromo"></v-checkbox>
              </v-flex>
              <v-flex xs6 v-else>
                <v-checkbox
                  v-model="form.promo_cardPromo"
                  :label="labels.promo_cardPromo"
                  :error-messages="errors.collect('promo_cardPromo')"
                  data-vv-name="promo_cardPromo"
                  :data-vv-as="labels.promo_cardPromo"
                  v-validate="'required'"
                ></v-checkbox>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs6 v-if="queryMode">
                <v-checkbox readonly v-model="form.promo_couponPromo" :label="labels.promo_couponPromo"></v-checkbox>
              </v-flex>
              <v-flex xs6 v-else>
                <v-checkbox
                  v-model="form.promo_couponPromo"
                  :label="labels.promo_couponPromo"
                  :error-messages="errors.collect('promo_couponPromo')"
                  data-vv-name="promo_couponPromo"
                  :data-vv-as="labels.promo_couponPromo"
                  v-validate="'required'"
                ></v-checkbox>
              </v-flex>

              <v-flex xs6 v-if="queryMode">
                <v-checkbox readonly v-model="form.promo_usrGrpPromo" :label="labels.promo_usrGrpPromo"></v-checkbox>
              </v-flex>
              <v-flex xs6 v-else>
                <v-checkbox
                  v-model="form.promo_usrGrpPromo"
                  :label="labels.promo_usrGrpPromo"
                  :error-messages="errors.collect('promo_usrGrpPromo')"
                  data-vv-name="promo_usrGrpPromo"
                  :data-vv-as="labels.promo_usrGrpPromo"
                  v-validate="'required'"
                ></v-checkbox>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container fluid grid-list-lg>
            <v-layout>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(createdDate) }}</div>
              </v-flex>
            </v-layout>
            <v-layout v-if="!newMode">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ modifiedBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(modifiedDate) }}</div>
              </v-flex>
            </v-layout>
          </v-container>
          <v-spacer class="mt-3"></v-spacer>
          <v-container fluid grid-list-lg>
            <v-btn class="mr-2" color="error" @click="doCancel" :loading="submitting">
              <span>Cancel</span>
              <v-icon right dark>mdi-cancel</v-icon>
            </v-btn>
            <v-btn :disabled="queryMode" color="primary" dark class="mr-2" @click="doSave" :loading="submitting">
              {{ newMode ? 'Save' : '' }}{{ reviewMode ? 'Update' : '' }}
              <v-icon right>mdi-content-save</v-icon>
            </v-btn>
          </v-container>
        </v-card-text>
      </v-card>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate, removeTime } from '@/utils/date'
import clone from 'clone'
export default {
  data() {
    return {
      labels: {
        promo_campaign: 'Promotion',
        promo_description: 'Description',
        promo_effDate: 'Effective Date',
        promo_expDate: 'Expiry Date ',
        promo_stdPromo: 'Standard Promotion',
        promo_cardPromo: 'Card Promotion',
        promo_couponPromo: 'Coupon Promotion',
        promo_usrGrpPromo: 'User Group Promotion',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      form: {
        actionKey: 'PROMOTION',
        promo_campaign: '',
        promo_description: '',
        promo_effDate: new Date(),
        promo_expDate: new Date(),
        promo_stdPromo: true,
        promo_cardPromo: false,
        promo_couponPromo: false,
        promo_usrGrpPromo: false
      },
      cloneQueryEffDate: '',
      cloneQueryExpDate: '',
      newMode: false,
      queryMode: false,
      reviewMode: false,
      submitting: false,
      createdBy: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
      createdDate: new Date(),
      modifiedBy: '',
      modifiedDate: undefined
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    async doFetch() {
      const apiURI = this.menu.getDetail
      if (apiURI) {
        this.loading = true
        try {
          const result = await this.$http.put(apiURI, this.objParam)
          const { data } = result.data
          if (data) {
            this.form.actionKey = data.promotionDto.actionKey
            this.form.promo_campaign = data.promotionDto.promo_campaign
            this.form.promo_description = data.promotionDto.promo_description
            this.form.promo_effDate = data.promotionDto.promo_effDate
            this.form.promo_expDate = data.promotionDto.promo_expDate
            this.form.promo_stdPromo = data.promotionDto.promo_stdPromo
            this.form.promo_cardPromo = data.promotionDto.promo_cardPromo
            this.form.promo_couponPromo = data.promotionDto.promo_couponPromo
            this.form.promo_usrGrpPromo = data.promotionDto.promo_usrGrpPromo
            this.createdBy = data.createdBy
            this.createdDate = data.createdDate
            this.modifiedBy = data.modifiedBy
            this.modifiedDate = data.modifiedDate
          }
          this.cloneQueryEffDate = clone(this.form.effDate)
          this.cloneQueryExpDate = clone(this.form.expDate)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doCancel() {
      this.$router.push({ name: 'promotionList' })
    },
    doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newMode) {
            this.doCreate()
          } else if (this.reviewMode) {
            this.doUpdate()
            // } else {
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.menu.doCreate
      if (apiURI) {
        this.submitting = true
        try {
          this.form.promo_effDate = removeTime(this.form.promo_effDate)
          this.form.promo_expDate = removeTime(this.form.promo_expDate)
          const result = await this.$http.post(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.message(data)
            this.fieldMessage(data)
            this.doCancel()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.menu.doUpdate
      if (apiURI) {
        this.submitting = true
        try {
          this.form.promo_effDate = removeTime(this.form.promo_effDate)
          this.form.promo_expDate = removeTime(this.form.promo_expDate)
          const result = await this.$http.put(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doCancel()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.campaignParam.menu
    },
    modeParam() {
      return this.$route.params.paramMode
    },
    objParam() {
      return this.$route.params.paramObjRes
    },
    effDateValidation() {
      return 'required'
    },
    expDateValidation() {
      if (this.form.promo_expDate !== undefined && this.form.promo_expDate !== '') {
        return 'required|start_enddate:' + this.form.promo_expDate
      } else {
        return 'required'
      }
    }
  },
  created() {
    if (this.modeParam === 'create') {
      this.newMode = true
    } else if (!this.modeParam) {
      this.doCancel()
    } else {
      if (this.modeParam === 'query') {
        this.queryMode = true
      } else if (this.modeParam === 'review') {
        this.reviewMode = true
      }
      this.doFetch()
    }
  },
  mixins: [MessageMixin]
}
</script>
